import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useAppContext } from "../_context";
import Button from "../components/Misc/Button";
import AppStoreLinks from "../components/Misc/AppStore/AppStoreLinks";
import Image from "next/image";
import Custom404 from "./404";
import Head from "next/head";
import { getMobileDeeplinkRoutes } from "../constants/mobileDeeplinkHelper";

const Invites = ({ inviteCode }) => {
  if (!inviteCode) {
    return <Custom404 />;
  }

  const [{ tx }] = useAppContext();

  const inviteMobileRoute = `${getMobileDeeplinkRoutes.invites}?ref_code=${inviteCode}`;

  return (
    <>
      <Head>
        <title>RacketPal - {tx["Invites"]}</title>
      </Head>
      <section className="section-referrals">
        <Row className="mx-0">
          <Col
            md={7}
            className="section-padding-y d-flex align-items-center content-section order-2 order-md-1">
            <div className="w-100">
              <div className="mb-7">
                <h1 className="mb-3">
                  {tx["Your friends are waiting for you"]}
                </h1>
                <h4 className="fw-normal mb-4">
                  {
                    tx[
                      "Download the RacketPal app, sign up and click below to use your referral code."
                    ]
                  }
                </h4>
                <Button href={inviteMobileRoute}>{tx["Use code"]}</Button>
              </div>
              <div>
                <h6 className="mb-3">{tx["Download now"]}</h6>
                <AppStoreLinks white={false} stacked={true} />
              </div>
            </div>
          </Col>
          <Col
            md={5}
            className="section-padding-y bg-primary position-relative order-1 order-md-2 graphic-container">
            <div className="graphic">
              <Image
                src="/img/referrals/phones.png"
                width={500}
                height={659}
                unoptimized={true}
              />
            </div>
          </Col>
        </Row>
      </section>
    </>
  );
};

export const getServerSideProps = async (context) => {
  return {
    props: {
      inviteCode: context?.query?.ref_code || null,
    },
  };
};

export default Invites;
